import { http, authHeader } from '@/http-commons';

class CancellationReasonDataService {

    getAllCancellationReason( params ){
        return http.get('api/v1/cancellationReason/table', { params, headers : authHeader() });
    }
    create( data ){
        return http.post('api/v1/cancellationReason/create', data, { headers : authHeader() });
    }
    show( id ){
        return http.get(`api/v1/cancellationReason/get/${id}`, { headers : authHeader() });
    }
    byModule( module ){
        return http.get(`api/v1/cancellationReason/byModule/${module}`, { headers : authHeader() });
    }
    update( data ){
        return http.put(`api/v1/cancellationReason/update/${data.id}`, data, { headers : authHeader() });
    }
    delete( id ){
        return http.delete(`api/v1/cancellationReason/delete/${id}`, { headers : authHeader() });
    }
}
export default new CancellationReasonDataService();
